import _ from 'lodash';
import {
    IServerCreationRequest,
    IServerUpdateRequest, Server, ServerBulkDeleteRequest,
    ServerCollection, ServerCreationRequest,
    ServerNewKeyRequest, ServersClient, ServerUpdateRequest, ServerMaintenanceModeRequest
} from '../clients/aasServerClient.generated';
import { TableFilters, TableSorting } from '../stores/tables/state';

export function getServers(
    limit: number, start: number,
    sorting: TableSorting,
    filters: TableFilters,
    searchString?: string
): Promise<ServerCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.getServers(
        false, true,
        limit, start, ordering,
        filters.a, searchString
    );
}

export function getServersNF(
    limit: number, start: number,
    sorting: TableSorting,

): Promise<ServerCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.getServers(
        false, true,
        limit, start, ordering,
        undefined, undefined
    );
}

export function getAllServers(): Promise<ServerCollection> {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.getServers(
        true, undefined,
        undefined, undefined, undefined,
        undefined, undefined
    );
}

export function getServer(id: string): Promise<Server> {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.getServer(id);
}

export function updateServer(
    server: Partial<Server>,
): Promise<Server> {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.updateServer(server.id!, new ServerUpdateRequest(server as IServerUpdateRequest));
}

export function createServer(
    server: Partial<Server>
): Promise<Server> {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.createServer(new ServerCreationRequest(server as IServerCreationRequest));
}

export function deleteServers(ids: string[]) {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkDeleteServers(new ServerBulkDeleteRequest({ ids }));
}

export function generateNewKeys(ids: string[]) {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.generateNewServerKey(new ServerNewKeyRequest({ ids }));
}

export function getMaintenanceMode(hostname: string): Promise<boolean> {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.getMaintenanceMode2(hostname);
}

export function setMaintenanceMode(hostname: string, value: boolean): Promise<boolean> {
    const client = new ServersClient(process.env.PUBLIC_URL + '/api');
    return client.setMaintenanceMode2(hostname, new ServerMaintenanceModeRequest({value}));
}
